import React, { Component } from 'react';
import Table5_10_1 from "./Table5_10_1";
import Table5_10_2 from "./Table5_10_2";
import Table5_10_3 from "./Table5_10_3";
import Table5_10_4 from "./Table5_10_4";
import Table5_10_5 from "./Table5_10_5";
import Table5_10_6 from "./Table5_10_6";
import Table5_10_7 from "./Table5_10_7";
import Table5_10_8 from "./Table5_10_8";
import { Row, Button, DatePicker, Spin, } from 'antd';
import moment from 'moment';
import request from '@/method/request';
import compute from './compute';
import Auth from "../../Auth";
import imgSave from "../../saveImg";
import ExportExcel from "@/method/components/ExportExcel"
import "./index.scss";

const { MonthPicker } = DatePicker;

export class index extends Component {
    state = {
        date: moment().subtract(1, 'month').format('YYYY-MM'),
        data: {},
        loading: true,
        loadingSave: false,
        print: false
    }

    componentDidMount() {
        this.getData(this.state.date);
    }

    getData = async (date) => {
        const res = await request(`/es5_10Info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`);
        this.setState({ loading: false, data: compute(res.data) });
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table5_6_1', 1.5, '5.10', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    onExport = (id, name = "单店分析") => {
        this.setState({ print: true, loading: true }, () => {
            ExportExcel({
                id,
                date: this.state.date,
                name
            });
            this.setState({ print: false, loading: false });
        });
    }

    render() {
        const { data, loading, print } = this.state;
        return (
            <Spin spinning={loading}>
                <div className="table7_1_1">
                    <Row className="title " id="table5_6_1" style={{ width: print ? 3400 : 'auto' }} >
                        <Row className="subtitle">5.10 单店分析</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: {},
                                        loading: true,
                                    });
                                    this.getData(str)
                                }}
                            />
                        </Row>
                        <Table5_10_1 {...this.props} data={data} print={print} onExport={this.onExport} />
                        <Table5_10_2 {...this.props} data={data} print={print} onExport={this.onExport} />
                        <Table5_10_3 {...this.props} data={data} print={print} onExport={this.onExport} />
                        <Table5_10_4 {...this.props} data={data} print={print} onExport={this.onExport} />
                        <Table5_10_5 {...this.props} data={data} print={print} onExport={this.onExport} />
                        <Table5_10_6  {...this.props} data={data} print={print} onExport={this.onExport} />
                        <Table5_10_7  {...this.props} data={data} print={print} onExport={this.onExport} />
                        <Table5_10_8  {...this.props} data={data} print={print} onExport={this.onExport} />
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_5_9">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                        </Row>
                    </Auth>

                </div>
            </Spin >
        )
    }
};

export default index;



// WEBPACK FOOTER //
// ./src/components/table/5.0/5-10/index.js